export const education = [
    {
        id: "master",
        degree: "Maestría en Informática Empresarial",
        school: "Universidad Nacional de Ingeniería",
        period: "2017 – 2019",
    },
    {
        id: "postgrad",
        degree: "Posgrado: Experto en Desarrollo en .NET",
        school: "Universidad Nacional de Ingeniería",
        period: "2015",
    },
    {
        id: "bachelor",
        degree: "Ingeniero de Sistemas",
        school: "Universidad Nacional de Ingeniería",
        period: "2010 – 2015",
    },
];

export const otherEducation = [
    {
        id: "mvc",
        title: "Desarrollo MVC con .NET Core",
        school: "Tecnasa",
        period: "2019",
    },
    {
        id: "web",
        title: "Desarrollo Web con HTML5, CSS3 y JavaScript",
        school: "Tecnasa",
        period: "2019",
    },
    {
        id: "android",
        title: "Desarrollo de Aplicaciones Android",
        school: "New Horizons",
        period: "2017",
    },
];
